import DevelopersPage from './developers-page';

export default DevelopersPage;
